import { render, staticRenderFns } from "./ResellerDeclineContract.vue?vue&type=template&id=7016675d&scoped=true&"
import script from "./ResellerDeclineContract.vue?vue&type=script&lang=js&"
export * from "./ResellerDeclineContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7016675d",
  null
  
)

export default component.exports